import { Badge } from "@/components/ui/badge";

const STAGE_STYLES = {
  NOT_STARTED: "bg-gray-100 text-gray-700 border-gray-200",
  IN_PROGRESS: "bg-orange-50 text-orange-700 border-orange-200",
  COMPLETED: "bg-green-50 text-green-700 border-green-200",
  SKIPPED: "bg-slate-100 text-slate-600 border-slate-200",
};

const PROJECT_STYLES = {
  PLANNED: "bg-blue-50 text-blue-700 border-blue-200",
  ACTIVE: "bg-green-50 text-green-700 border-green-200",
  ON_HOLD: "bg-amber-50 text-amber-700 border-amber-200",
  COMPLETED: "bg-slate-100 text-slate-600 border-slate-200",
  CANCELLED: "bg-red-50 text-red-700 border-red-200",
};

const SUMMARY_STYLES = {
  GENERATED: "bg-blue-50 text-blue-700 border-blue-200",
  REVIEWED: "bg-purple-50 text-purple-700 border-purple-200",
  SENT_TO_CLIENT: "bg-green-50 text-green-700 border-green-200",
  NO_ACTIVITY: "bg-gray-100 text-gray-600 border-gray-200",
  FAILED: "bg-red-50 text-red-700 border-red-200",
};

const ALL = { ...STAGE_STYLES, ...PROJECT_STYLES, ...SUMMARY_STYLES,
  ON_TRACK: "bg-green-50 text-green-700 border-green-200",
  SLIPPING: "bg-red-50 text-red-700 border-red-200" };

export function StatusBadge({ status, className = "" }) {
  return (
    <Badge
      variant="outline"
      className={`font-medium border ${ALL[status] || "bg-muted text-muted-foreground"} ${className}`}
      data-testid={`status-badge-${status}`}
    >
      {String(status).replace(/_/g, " ")}
    </Badge>
  );
}
